export const APPLICATIONS_NAME: Map<string, string> = new Map(
  Object.entries({
    adverseevents: 'aeWatch',
    audiobooks: 'AudioBooks',
    automation: 'Automation',
    autoparts: 'AutoParts',
    autopartsra: 'AutoPartsRA',
    billing: 'Billing',
    brokers: 'brokerWatch',
    carrental: 'Cars',
    courts: 'Courts',
    cruises: 'Cruises',
    drug_watch: 'ctWatch',
    cyberprice: 'cyberPrice',
    drugs: 'Drugs',
    ferry: 'Ferry',
    financial: 'Financial',
    airfare: 'Flights',
    homegoods: 'HomeGoods',
    homeimprovement: 'HomeImprovement',
    hotel: 'Hotels',
    journal: 'Journals',
    newswatch: 'newsWatch',
    ra: 'RA',
    rentmarketer: 'Rental Entry',
    rental_markets: 'Rental Markets',
    retail: 'Retail',
    rollups: 'Rollups',
    site_view: 'siteWatch',
    custom: 'Solutions',
    tires: 'Tires',
    vacation: 'Vacations',
  })
);

APPLICATIONS_NAME.set('autoparts-ra', 'AutoPartsRA');

export const getApplicationsName = (appName: string): string | undefined => {
  if (appName !== null) {
    return APPLICATIONS_NAME.get(appName.toLowerCase());
  }
};
